import { Injectable } from '@angular/core';
import { RouterFacade } from '../state/router/router.facade';

@Injectable({
  providedIn: 'root',
})
export class NavigateUserService {
  constructor(private routerFacade: RouterFacade) {}

  navigateUserToAbsolutePath(path: string): void {
    this.routerFacade.go({
      path: [path],
    });
  }
}
